<template>
    <div class="hero">
      <div class="hero-body is-full">
        <p></p>
        <br>
        <br>
        <b-message type="is-success">
          <h2 class="alert-heading">Completed!</h2>
          <p>Thank you, you have successfully completed signing your document. </p>
          <hr>
          <p class="mb-0">You can download a copy of the signed document below for your personal records. You may close this window at your convenience.</p>
        </b-message>
        <div class="column is-12">
          <div class="field is-full has-text-left" v-if="hasPdfFile">
            <file-selector v-model="pdfFiles" label="Signed Document" :multiple="false" :token="this.token" :required="false" :isBoxed="false" :enabled="false" :showFileOnly="true" destinationUrl="/upload/receive" :usePortalViewer="false"></file-selector>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import printRequestService from '@/services/printRequestService'
import FileSelector from '@/components/generic/FileSelector'
import utilitiesMixin from '@/mixins/generic/utilities'
export default {
  created () {
    this.$emit('is-home', false)
  },
  data () {
    return {
      pdfFiles: [],
      isSaving: false,
      serverErrorMessage: '',
      isLoading: false
    }
  },
  components: {
    'file-selector': FileSelector
  },
  props: {
    printRequestId: {
      type: Number,
      default: 0
    },
    token: {
      type: String,
      default: ''
    }
  },
  mixins: [utilitiesMixin],
  methods: {
    loadPrintRequest: function (id) {
      this.currentPrintRequestId = id
      this.isLoading = true
      this.serverErrorMessage = ''

      printRequestService.single(this.currentPrintRequestId).then(response => {
        this.isLoading = false
        this.currentPrintRequest = {
          ...response
        }
        this.currentPrintRequest.attachments.forEach((item) => {
          item.loaded = true
          item.imageData = item.fileLocation
          item.fileType = this.getFileType(item.fileLocation)
          if (item.classType === 'Sign') {
            this.pdfFiles.push(item)
          }
        })
      }).catch((error) => {
        this.isLoading = false
        this.onError(error)
      })
    },
    onError: function (error) {
      this.serverErrorMessage = error.message
      this.isLoading = false
      this.isSaving = false
    }
  },
  mounted: function () {
    const printRequestId = (this.printRequestId === 0) ? this.$route.params.id : this.printRequestId
    this.loadPrintRequest(printRequestId)
    this.$emit('set-title-one', 'PRINT REQUEST')
    this.$emit('set-title-two', 'COMPLETE')
  },
  computed: {
    hasPdfFile: function () {
      return this.pdfFiles && this.pdfFiles.length > 0
    }
  }
}
</script>
